import React, { Component } from "react";

//Components imports
import AliceCarousel from "react-alice-carousel";
import BioItem from "./bio-item";
import Bios from "../models/bios";
import ComponentHOC from "../hoc/ComponentHOC";
import InternalBanner from "./internal-banner";
import PropTypes from "prop-types";
import bioBackground from "../img/bio-background.png";
//Images imports
import { connect } from "react-redux";

class BioComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
    };
  }
  slideTo = (i) => this.setState({ currentIndex: i });

  onSlideChanged = (e) => this.setState({ currentIndex: e.item });

  slideNext = () =>
    this.setState({ currentIndex: this.state.currentIndex + 1 });

  slidePrev = () =>
    this.setState({ currentIndex: this.state.currentIndex - 1 });

  renderGallery() {
    const { currentIndex } = this.state;
    const { list } = this.props;
    const responsive = {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1024: {
        items: 1,
      },
    };
    return (
      <AliceCarousel
        duration={400}
        autoPlay={false}
        startIndex={0}
        swipeDisabled={1} //disabling swipe
        fadeOutAnimation={false}
        playButtonEnabled={false}
        responsive={responsive}
        slideToIndex={currentIndex}
        autoPlayInterval={5000}
        onSlideChange={this.onSlideChange}
        onSlideChanged={this.onSlideChanged}
        buttonsDisabled={true}
        dotsDisabled={true}
      >
        {list.map((item, index) => {
          return <BioItem key={index} item={new Bios(item)} />;
        })}
      </AliceCarousel>
    );
  }
  render() {
    const { banner, list } = this.props;
    return (
      <section className="bio-section">
        <div className="container banner-container bio-background">
          {/* <InternalBanner banner={banner}/> */}
          {list.length > 0 ? (
            <div className="row justify-content-center align-items-center bio-content-slider">
              <div className="col-12 col-lg-8 carousel-control">
                {this.renderGallery()}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </section>
    );
  }
}

BioComponent.propType = {
  list: PropTypes.array.isRequired,
  banner: PropTypes.string.isRequired,
};

export default connect((state) => state)(ComponentHOC(BioComponent));



// WEBPACK FOOTER //
// ./src/components/bio.js